import { useState, useEffect, memo } from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import { Box, Flex, Image } from '@chakra-ui/react';
import PublicDsrJoinRoomForm from './PublicDsrJoinRoomForm';
import { joinPublicDsr, resetJoinPublicDsr } from '../../../digital-sales-room/actions/public-dsr-actions.js'
import logo from '../../../global/styles/images/launchdeck_logo.svg';
import { redirectToNewPage, validateEmail } from '../../../global/helpers/global-helpers.js';
import PublicDsrJoinRoomLoginForm from './PublicDsrJoinRoomLoginForm.jsx';
import PublicDsrJoinRoomCreateUserForm from './PublicDsrJoinRoomCreateUserForm.jsx';
import { splitNameInput } from '../../../profile/helpers/user-helper.js';
import DsrJoinPublicDsrSetPasswordForm from '../../dsr-access-mgmt/DsrJoinPublicDsrSetPasswordForm.jsx';
// import DsrAccessCodeChallengeModule from '../../dsr-access-mgmt/DsrAccessCodeChallengeModule.jsx';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal.jsx';
import UnexpectedErrorPage from '../../../global/components/helper-components/components/UnexpectedErrorPage.jsx';


function SignupLoginModal({
  dsrId, 
  handleCloseModal,
  // Actions
  joinPublicDsr,
  resetJoinPublicDsr,
  // Redux states
  joinPublicDsrOutcome,
  dsrDisplayLogoImages
}) {

  const [displayedForm, setDisplayedForm] = useState("check-email-form")

  const [processedEmailAddress, setProcessedEmailAddress] = useState("")
  const [greetingName, setGreetingName] = useState("")
  const [createUserAuthToken, setCreateUserAuthToken] = useState("")
  const [processedUserIdToken, setProcessedUserIdToken] = useState("")
  const [newProfileToken, setNewProfileToken] = useState("")

  // Inputs
  const [userEmailInput, setUserEmailInput] = useState("")
  const [loginPasswordInput, setLoginPasswordInput] = useState("")
  const [joinerNameInput, setJoinerNameInput] = useState("")
  const [companyNameInput, setCompanyNameInput] = useState("")
  const [companyRoleInput, setCompanyRoleInput] = useState("")
  const [createdPasswordInput, setCreatedPasswordInput] = useState("")

  // Error Handling
  const [showEmailInputError, setShowEmailInputError] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showIncorrectPasswordError, setShowIncorrectPasswordError] = useState(false);
  const [showNameInputError, setShowNameInputError] = useState(false);
  const [showCreatedPasswordInputError, setShowCreatedPasswordInputError] = useState(false);

  // UX
  const [redirectingUser ,setRedirectingUser] = useState(false);
  const [showGuestLogo, setShowGuestLogo] = useState(true)
  const [joinPublicDsrIsProcessing, setJoinPublicDsrIsProcessing] = useState(false);

  
  useEffect(() => {
    if (joinPublicDsrOutcome) {
      const { nextStep, processedEmail, processedUserIdToken, pendingUserIdToken, pendingUserNewProfiletoken, greetingName, createNewUserToken, processSuccessful } = joinPublicDsrOutcome || {}

      if (processSuccessful && nextStep) {
        switch (nextStep) {
          case ("password-login-prompt"): {
            setDisplayedForm("existing-user-login-form")
            break;
          }
          case ("create-new-user-account"): {
            setDisplayedForm("create-new-user-form")
            setCreateUserAuthToken(createNewUserToken)
            break;
          }
          case("login-and-redirect-to-dsr"): {
            redirectToNewPage(dsrId ? `/dsr/${dsrId}` : `/home`)
            setRedirectingUser(true)
            break;
          }
          case("show-unsuccessful-login"): {
            setLoginPasswordInput("")
            setShowIncorrectPasswordError(true)
            setDisplayedForm("existing-user-login-form")
          
            break;
          }
          case("set-password-edit-profile"): {
            setDisplayedForm("set-password-form")
            setProcessedUserIdToken(pendingUserIdToken)
            setNewProfileToken(pendingUserNewProfiletoken)
            break;
          }
          case("show-failed-email-validation"): {
            setShowEmailInputError(true)
            break;
          }
          case("seek-invite-from-owner"): {
            setProcessedUserIdToken(processedUserIdToken)
            setDisplayedForm("seek-invite-from-owner")
            break;
          }
          case("encountered-unexpected-error"):  {
            resetAllInputsAndErrorStates()
            setDisplayedForm("encountered-unexpected-error")
        
            break;
          }
          default: {
            setDisplayedForm("check-email-form")
            break;
          }
        }
      } else {
        resetAllInputsAndErrorStates()
        setDisplayedForm("encountered-unexpected-error")
      }

      if (processedEmail) {
        setProcessedEmailAddress(processedEmail)
      }

      if (greetingName) {
        setGreetingName(greetingName)
      }

      setJoinPublicDsrIsProcessing(false)
      resetJoinPublicDsr()
    }
  }, [joinPublicDsrOutcome, resetJoinPublicDsr])


  const onChangeHandler = (event) => {

    switch (event.target.name) {
      case ('email'): {
        setUserEmailInput(event.target.value.trim())
        break;
      }
      case ('login-password-input'): {
        if (showPasswordError) {
          setShowPasswordError(false)
        }

        setLoginPasswordInput(event.target.value)
        break;
      }
      case("created-password-input"): {
        if (showCreatedPasswordInputError) {
          setShowCreatedPasswordInputError(false)
        }

        setCreatedPasswordInput(event.target.value)
        break;
      }
      case("joiner-name-input"): {
        if (showNameInputError) {
          setShowNameInputError(false)
        }

        setJoinerNameInput(event.target.value)
        break;
      }
      case("company-name-input"): {

        setCompanyNameInput(event.target.value)
        break;
      }
      case("company-role-input"): {
       
        setCompanyRoleInput(event.target.value)
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleCheckUserEmail = () => {
    const trimmedEmail = userEmailInput.toLowerCase().trim()
    const isValidEmail = validateEmail(trimmedEmail)

    if (!isValidEmail) {
      setShowEmailInputError(true)
    } else {
      const joinPublicDsrPayload = {
        event: 'check-if-existing-user',
        email: trimmedEmail,
        dsrId: dsrId
      }

      setJoinPublicDsrIsProcessing(true)
      joinPublicDsr(joinPublicDsrPayload)
    }
  }

  const handleLoginJoinRoom = () => {
    if (loginPasswordInput?.length < 6) {
      setShowPasswordError(true)
    } else if (loginPasswordInput && processedEmailAddress) {

      const joinPublicDsrPayload = {
        event: 'login-existing-user',
        email: processedEmailAddress,
        passwordInput: loginPasswordInput,
        dsrId: dsrId
      }

      setJoinPublicDsrIsProcessing(true)
      joinPublicDsr(joinPublicDsrPayload)
    }
  }

  const handleCreateRoomJoiner = () => {

    if (!joinerNameInput) {
      setShowNameInputError(true)
    } 
    
    if (createdPasswordInput?.length < 6) {
      setShowCreatedPasswordInputError(true)
    } 
    
    if (joinerNameInput && createdPasswordInput?.length >= 6) {
      const {firstName, lastName} = splitNameInput(joinerNameInput)

      const joinPublicDsrPayload = {
        event: 'create-new-joiner-account',
        email: processedEmailAddress,
        dsrId: dsrId, 
        firstName: firstName.trim(),
        ...(lastName && {lastName: lastName.trim()}),
        companyName: companyNameInput.trim(),
        companyRole: companyRoleInput.trim(),
        createdPassword: createdPasswordInput,
        createUserAuthToken: createUserAuthToken
      }

      setJoinPublicDsrIsProcessing(true)
      joinPublicDsr(joinPublicDsrPayload)
    }
    
  }

  const resetAllInputsAndErrorStates = () => {
    setShowEmailInputError(false)
    setShowPasswordError(false)
    setShowNameInputError(false)
    setShowIncorrectPasswordError(false)
    setShowCreatedPasswordInputError(false)
    setDisplayedForm("")
    setProcessedEmailAddress("")
    setUserEmailInput("")
    setLoginPasswordInput("")
    setJoinerNameInput("")
    setCompanyNameInput("")
    setCompanyRoleInput("")
    setCreatedPasswordInput("")
    setProcessedUserIdToken("")
  }

  const handleClickModalCloseButton = () => {
    resetAllInputsAndErrorStates()
    handleCloseModal()
  }

  const handleSetPasswordProfile = (newPasswordInput, newProfileToken, firstNameInput, lastNameInput) => {
    if (dsrId && newPasswordInput && newProfileToken) {
  
      const joinPublicDsrPayload = {
        event: 'pending-existing-user-join-public-dsr',
        email: processedEmailAddress,
        dsrId: dsrId, 
        newPasswordInput,
        newProfileToken,
        firstNameInput,
        lastNameInput
      }

      setJoinPublicDsrIsProcessing(true)
      joinPublicDsr(joinPublicDsrPayload)
    }
  }

  const renderForm = () => {
      switch (displayedForm) {
        case ('existing-user-login-form'): {
          return (
            <PublicDsrJoinRoomLoginForm
              handleLoginJoinRoom={handleLoginJoinRoom}
              onChangeHandler={onChangeHandler}
              processedEmailAddress={processedEmailAddress}
              loginPasswordInput={loginPasswordInput}
              showPasswordError={showPasswordError}
              greetingName={greetingName}
              showIncorrectPasswordError={showIncorrectPasswordError}
              isProcessing={joinPublicDsrIsProcessing || redirectingUser}
            />
          );
        }
        case ('create-new-user-form'): {
          return ( 
            <PublicDsrJoinRoomCreateUserForm 
            handleCreateRoomJoiner={handleCreateRoomJoiner}
            onChangeHandler={onChangeHandler}
            showCreatedPasswordInputError={showCreatedPasswordInputError}
            showNameInputError={showNameInputError}

            joinerNameInput={joinerNameInput}
            createdPasswordInput={createdPasswordInput}
            companyNameInput={companyNameInput}
            companyRoleInput={companyRoleInput}
            isProcessing={joinPublicDsrIsProcessing || redirectingUser}

            />
          );
        }
        case ('set-password-form'): {
          return (
            <>
              <DsrJoinPublicDsrSetPasswordForm
              newUserId={processedUserIdToken}
              newProfileToken={newProfileToken}
              defaultEmail={processedEmailAddress}
              handleSetPasswordProfile={handleSetPasswordProfile}
              isProcessing={joinPublicDsrIsProcessing || redirectingUser}
            />
          </>
          )
        }
        case ('encountered-unexpected-error'): {
          return <UnexpectedErrorPage />
        }
        case ('check-email-form'): 
        default:{
          return (
            <PublicDsrJoinRoomForm
              handleCheckUserEmail={handleCheckUserEmail}
              onChangeHandler={onChangeHandler}
              showEmailInputError={showEmailInputError}
              userEmailInput={userEmailInput}
              isProcessing={joinPublicDsrIsProcessing || redirectingUser}
            />
          )
        }
      }
    // }
  }

  const renderLogos = () => {
    const {
      displayedAudienceLogo,
      displayedHostLogo
    } = dsrDisplayLogoImages || {};

    if (displayedHostLogo) {
      return (
        <Flex w='100%' justify='center'>
          <Image src={displayedHostLogo} alt="Host Logo" width='50%' minWidth='1em' maxWidth='5em' mb='2em' />
          {displayedAudienceLogo && showGuestLogo && <Image src={displayedAudienceLogo} alt="Guest Logo" width='50%' minWidth='1em' maxWidth='5em' mb='2em' ml='1.5em'  onError={() => setShowGuestLogo(false)}/>}
        </Flex>
      )

    } else {
      return (

        <Flex w='100%' justify='center'>
          <Image src={logo} alt="Launchdeck Logo" width='50%' minWidth='1em' maxWidth='5em' mb='2em'/>
        </Flex>
      )
    }
  }


  const displayContent = () => {
    return (
      <Box w='100%'>
        <Flex direction='column' justify='center' alignItems='center' p={'1.5em 1em'} w='100%'>
          {renderLogos()}
          {renderForm()}
        </Flex>
      </Box>
    )
  }

 
  return (
    <LaunchdeckModal
      title=''
      handleCloseModal={handleClickModalCloseButton}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}



const mapStateToProps = (state) => ({
  dsrDisplayLogoImages: state.dsrDisplayLogoImages.dsrDisplayLogos,
  joinPublicDsrOutcome: state.joinPublicDsrOutcome.results.data
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      joinPublicDsr,
      resetJoinPublicDsr
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(SignupLoginModal)))
